export default __webpack_public_path__ + "static/web-dev-header-df056647feecab41d45a6c31aa81b9b5.jpg";